'use client';

import { useSelector } from 'react-redux';
import { selectIsFurniture } from '@next-app/lib/features/InitSelectors';
import Conditional from '@next-app/components/Conditional';
import {
  hideExtraBackdrops,
  isNotNullOrUndefined,
} from '@next-app/utils/common-utils';
import { forwardRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import LLHeading from '../LLHeading/LLHeading';
import Button from '../Button/Button';

interface DynamicModalProps {
  modalContentClass?: string;
  centerClass?: string;
  modalTitle?: any;
  headingTagName?: '1' | '2' | '3' | '4' | '5' | '6';
  onModalClose?: Function;
  children?: any;
  automationId?: string;
  showTitleBg?: boolean;
}

const DynamicModal = forwardRef((props: DynamicModalProps, ref: any) => {
  const {
    modalContentClass,
    centerClass,
    modalTitle,
    headingTagName = '4',
    showTitleBg = true,
    onModalClose,
    automationId = '',
  } = props;
  const portalDiv = document.getElementById('dynamicModal')!;
  const isFurniture = useSelector(selectIsFurniture);

  useEffect(() => {
    const myModal = document.getElementById('dynamicModalWrapper');
    hideExtraBackdrops();
    myModal?.addEventListener('hidden.bs.modal', () => {
      if (onModalClose) {
        onModalClose();
        document.body.style.overflow = 'auto';
      }
    });

    return () => {
      myModal?.removeEventListener('hidden.bs.modal', () => {
        console.log('Event listener removed');
      });
    };
  }, [portalDiv, onModalClose]);

  return (
    <>
      {createPortal(
        <div className={`w-100 ${isFurniture ? 'f-style' : ''}`}>
          <div
            className={`modal-content ${isFurniture ? 'rounded-0' : 'rounded-10'} mx-auto ${modalContentClass}`}
          >
            <Conditional if={isNotNullOrUndefined(modalTitle)}>
              <div
                className={`modal-header ${showTitleBg ? '' : 'no-bg'} p-ll-20 rounded-top-10`}
              >
                <LLHeading tagName="3" className="5">
                  {modalTitle}
                </LLHeading>
                <Button
                  automationId={
                    typeof modalTitle === 'string'
                      ? `close-${modalTitle?.toLowerCase().trim().replaceAll(' ', '-')}-modal`
                      : `close-${automationId}-modal`
                  }
                  data-testid="close-modal-button"
                  type="button"
                  variant="transparent"
                  customClass={`position-absolute p-0 border-0 close-icon`}
                  aria-label="Close"
                  data-bs-dismiss="modal"
                  data-dismiss="dynamicModalWrapper"
                ></Button>
              </div>
            </Conditional>

            <div className={`p-ll-20`}>{props.children}</div>
          </div>
        </div>,
        portalDiv,
      )}
    </>
  );
});
DynamicModal.displayName = 'DynamicModal';
export default DynamicModal;
